$(document).on("click", ".overlay_close__button", function() { 
  $("#overlay-panel").hide();
  return false;
});